<template>
  <div class="box">
    <img class="title-banner" src="../assets/img/banner.png">
    <div class="box-center vs-column vs-align-center">
      <div class="box-center-title font-30">广西公共法律服务简介</div>
      <div class="title-line margin-bottom-60"></div>
      <div class="box-center-content font-18">
        <div class="box-center-content-text">
          2021年1至10月，全区各级公共法律服务机构共办理法律援助案件28413件，办理公证业务108815件，办理司法鉴定业务50028件，办理仲裁业务39902件，办理人民调解163458件。目前全区拥有各类公共法律服务机构2000多个，公共法律服务工作队伍13多万人。其中，律师事务所856个，执业律师11703名；基层法律服务所354个，基层法律服务工作者3042名；法律援助机构120个，法律援助工作者439名；公证机构94个，公证员314名；司法鉴定机构51个，司法鉴定人588名；仲裁机构14个，仲裁员5717名；人民调解组织18857个，人民调解员10万多名。
        </div>
        <div class="box-center-content-center width-100 vs-row">
          <div class="box-center-content-btn" v-for="(item, index) in titleList" :key="index" @click="cilTitle()" :class="item.id?'box-center-content-btn1':''">{{item.name}}</div>
        </div>
        <div class="box-center-content-text" v-if="titleList[0].id">
          公共法律服务是政府公共职能的重要组成部分，是保障和改善民生的重要举措，是全面依法治国的基础性、服务性和保障性工作，是由党委领导、政府主导、社会参与，为满足各类主体在社会公共生活中日益增长的法律服务需求而提供的公共法律服务设施、服务产品、服务活动以及其他相关法律服务，主要包括法治宣传教育、律师、公证、法律援助、基层法律服务、法律顾问、人民调解、仲裁、司法鉴定、法律职业资格考试等方面。公共法律服务既包括无偿或公益性法律服务，也包括面向社会公众有偿性的法律服务。
        </div>
        <div class="box-center-content-text" v-if="titleList[1].id">
          公共法律服务包括热线、网络、实体三大平台。获取公共法律服务的三大途径：群众可拨打“12348”公共法律服务热线、登录广西法律服务网<span class="color-bulr" @click="jump('a')">（gx.12348.gov.cn）</span>及下载手机移动终端（广西法网·桂法通APP）或到各地公共法律服务中心、站、室寻求法律服务。
        </div>
      </div>
    </div>
    <div class="box-bottom vs-column vs-align-center margin-bottom-60">
      <div class="box-center-title font-30">广西公共法律服务应用</div>
      <div class="title-line margin-bottom-60"></div>
      <div class="box-center-content font-18 vs-row vs-space-between vs-align-center">
        <div class="box-center-content-list vs-column vs-align-center">
            <img class="width-100" src="../assets/img/card1.png">
            <div class="box-center-content-list-title font-20 margin-bottom-20">法律智能咨询</div>
            <div class="box-bottom-content-text">
              广西公共法律服务智能咨询应用，基于人工智能的先进技术，打造“AI+公共法律服务”平台，为政府机构、律所和律师、有法律诉求的群体提供相关法律咨询服务。智能咨询应用通过自然语言处理识别用户法律诉求...
            </div>
            <div class="moreText font-20 color-white" @click="jump('url')">更多</div>
        </div>
        <div class="box-center-content-list vs-column vs-align-center">
            <img class="width-100" src="../assets/img/card2.png">
            <div class="box-center-content-list-title font-20 margin-bottom-20">广西法网·桂法通APP</div>
            <div class="box-bottom-content-text">
            “广西法网·桂法通”APP是依托广西法律服务网开发的首个移动手机客户端。为打造集“法律咨询、司法行政诉求”为一体的“老百姓身边的法律助手”APP，逐步推行所有法律服务事项网上咨询、查询、受理、办理...
            </div>
            <div class="moreText font-20 color-white" @click="jump('/gftAPP')">更多</div>
        </div>
        <div class="box-center-content-list vs-column vs-align-center">
            <img class="width-100" src="../assets/img/card3.png">
            <div class="box-center-content-list-title font-20 margin-bottom-20">12348公共法律服务热线</div>
            <div class="box-bottom-content-text">
            “12348"是自治区司法厅面向全区群众的法律咨询专用热线，它受理解答群众的法律咨询，配合调处民间纠纷，及时反映群众的法律需求信息，指导和接受法律援助申请，维护司法公正、社会稳定及贫弱当事人的合法权益。
            </div>
            <div class="moreText font-20 color-white" @click="jump('/hot')">更多</div>
        </div>
        <div class="box-center-content-list vs-column vs-align-center">
            <img class="width-100" src="../assets/img/card4.png">
            <div class="box-center-content-list-title font-20 margin-bottom-20">客户端下载</div>
            <div class="box-bottom-content-text">
              “广西法网 · 桂法通 · 终端机APP”整合了法律咨询、法律服务机构和人员信息查询、司法行政业务办理、普法宣传等各项司法行政业务，免费提供24小时热线咨询、留言解答、智能解答，在线申办公证、法律援助等业务。
            </div>
            <div class="moreText font-20 color-white" @click="jump('/clientDownload')">更多</div>
        </div>
      </div>
    </div>
    <div class="box-footer vs-column vs-space-center vs-align-center font-16">
      <div>主办单位：广西壮族自治区司法厅主办 </div>
      <div>技术支持：南宁城市通信息科技有限公司    0771-5555551</div>
      <div class="box-footer-records" @click="jump('records')">桂ICP备19008147号-1</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'index',
    data () {
      return {
        titleList: [
          {name:'什么是公共法律服务？',id:true},
          {name:'去哪里找公共法律服务？',id:false},
        ]
      }
    },
    mounted() {
    },
    methods: {
      cilTitle() {
        this.titleList.forEach( e=> {
          e.id = !e.id
        })
        this.$forceUpdate()
      },
      jump(data) {
        if(data==='url') {
          window.open('https://gft-res.citycome.top/znzx-pc/index.html#/','target','');
        }else if(data==='a') {
          window.open('http://gx.12348.gov.cn/','target','');
        }else if(data==='records') {
          window.open('https://beian.miit.gov.cn/#/Integrated/index','target','');
        } else {
          // this.$router.push(data)
          let routeData = this.$router.resolve({
            path: data,
          })
          window.open(routeData.href, '_blank')
        }
      }
    }
  }
</script>

<style scoped>

.box {
    width: 100%;
    min-width: 920px;
  font-family: "Microsoft YaHei";
  }
.title-banner {
  width: 100%;
  /*height: 502px;*/
}
.box-center {
  width: 100%;
  /*height: 690px;*/
  background-image: url("../assets/img/bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100px;
}
.box-bottom {
  width: 100%;
  background-image: url("../assets/img/bg2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
  .box-center-title {
    color: rgb(51, 51, 51);
    padding-top: 72px;
    padding-bottom: 32px;
  }
  .title-line {
    width: 84px;
    height: 7px;
    background-color: #3c6fc7;
  }
  .box-center-content {
    width: 100%;
    padding: 0 120px;
    color: rgb(102, 102, 102);
  }
  .color-bulr {
    color: #3c6fc7;
  }
  .box-center-content-text {
    width: 100%;
    text-align: left;
    line-height: 35px;
    text-indent: 40px;
  }
  .box-center-content-center {
    width: 100%;
    margin: 50px 0;
    padding-left: 10px;
  }
  .box-center-content-btn {
    /*width: 205px;*/
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 10px;
    padding: 0 16px;
    background-color: #fcfcfc;
    color: #999999;
    border: 2px solid #D2D2D2;
    margin-right: 50px;
  }
.box-center-content-btn1 {
    background-color: #e89200;
    border: 2px solid #e89200;
    color: #fff;
  }
  .box-center-content-list {
    /*width: calc(100% / 3);*/
    width: 377px;
    /*height: 680px;*/
    /*display: table-cell;*/
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 0 20px #fafafa;
  }
  .box-center-content-list1 {
    width: calc(100% - 30px);
    border-radius: 5px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0 0 20px #fafafa;
  }
.box-bottom-content-text {
  width: 100%;
  /*height: 286px;*/
  text-align: left;
  line-height: 35px;
  text-indent: 40px;
  padding: 0 40px 20px;
  /*overflow-x: hidden;*/
}

.box-center-content-list-title {
  width: 100%;
  color: rgb(51, 51, 51);
  text-align: center;
  font-weight: bold;
}
.moreText {
  width: 100px;
  height: 45px;
  line-height: 45px;
  border-radius: 10px;
  background-color: #336dfa;
  /*margin-top: 20px;*/
  margin-bottom: 20px;
}
  .box-footer {
    width: 100%;
    height: 98px;
    background-color: #336dfa;
    padding: 0 389px;
    color: #D1E6FF;
    font-weight: bold;
  }
  .box-footer div {
    width: 422px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .box-footer-records {
    width: 422px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }
@media (max-width: 1520px) {
  .box-center-content-list{
    /*height: 588px;*/
  }
}
@media (max-width: 1800px) {
  .moreText {
    margin-top: 20px;
  }
  .box-center-content {
    padding: 0 320px;
  }
}
@media (max-width: 1700px) {
  .box-center-content {
    padding: 0 260px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/index.vue